// color-swatches.js
const COLOR_MAP = {
  'Amarillo': '#FFFF00',
  'AZUL': '#0000FF',
  'Azul': '#0000FF', 
  'Beige': '#F5F5DC',
  'Blanco': '#FFFFFF',
  'CAFÉ': '#A52A2A',
  'Celeste': '#87CEEB',
  'Gris': '#808080',
  'Gris Claro': '#D3D3D3',
  'Morado': '#800080',
  'Multicolor': 'multicolor',
  'Naranja Fluor': '#FF5F1F',
  'Naranjo': '#FFA500',
  'Negro': '#000000',
  'Rojo': '#FF0000',
  'Rosado': '#FFC0CB',
  'Verde': '#008000'
};

function normalizeText(text) {
  return text.toLowerCase().trim();
}

const MULTICOLOR_GRADIENT_ID = 'FacetMulticolorGradient';

function ensureMulticolorGradient() {
  if (document.getElementById(MULTICOLOR_GRADIENT_ID)) return;
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', '0');
  svg.setAttribute('height', '0');
  svg.setAttribute('aria-hidden', 'true');
  svg.style.position = 'absolute';
  svg.innerHTML = `
    <defs>
      <linearGradient id="${MULTICOLOR_GRADIENT_ID}" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stop-color="#FF0000"/>
        <stop offset="0.25" stop-color="#FFD400"/>
        <stop offset="0.5" stop-color="#00B050"/>
        <stop offset="0.75" stop-color="#0070FF"/>
        <stop offset="1" stop-color="#8000FF"/>
      </linearGradient>
    </defs>`;
  document.body.appendChild(svg);
}

function isLightColor(hexColor) {
  if (!hexColor.startsWith('#')) return false;
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 155;
}

class SimpleColorCheckboxManager {
  constructor() {
    this.processedElements = new WeakSet();
    this.observer = null;
    this.normalizedColorMap = Object.entries(COLOR_MAP).reduce((acc, [key, value]) => {
      acc[normalizeText(key)] = value;
      return acc;
    }, {});
  }

  init() {
    this.observer = new MutationObserver(() => this.updateColorCheckboxes());
    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    this.updateColorCheckboxes();
  }

  updateColorCheckboxes() {
    const filterLabels = document.querySelectorAll('.facets__label:not([data-color-filter]), .mobile-facets__label:not([data-color-filter])');
    
    filterLabels.forEach(label => {
      if (this.processedElements.has(label)) return;
      
      const textElement = label.querySelector('.facet-checkbox__text-label');
      if (!textElement) return;
      
      const colorName = textElement.textContent.trim();
      const normalizedColorName = normalizeText(colorName);
      const colorHex = this.normalizedColorMap[normalizedColorName];
      
      if (colorHex) {
        this.processedElements.add(label);
        label.setAttribute('data-color-filter', 'true');
        
        if (isLightColor(colorHex)) {
          label.classList.add('light-color');
        }
        
        const rect = label.querySelector('svg rect');
        if (rect && colorHex === 'multicolor') {
          ensureMulticolorGradient();
          rect.setAttribute('fill', `url(#${MULTICOLOR_GRADIENT_ID})`);
          rect.setAttribute('stroke', 'none');
        } else if (rect) {
          rect.setAttribute('fill', colorHex);
          rect.setAttribute('stroke', isLightColor(colorHex) ? '#ddd' : colorHex);
        }
      }
    });
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

// Inicializar
const checkboxManager = new SimpleColorCheckboxManager();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => checkboxManager.init());
} else {
  checkboxManager.init();
}